import React from 'react';
import { IconUser } from '@tabler/icons-react';

const CoachSection = () => {
  return (
    <section className="ub-coach-section">
      <div className="ub-coach-placeholder">
        <IconUser size={64} color="#ffd700" strokeWidth={1.5} />
        <p className="ub-placeholder-text">Coach directory coming soon</p>
      </div>
    </section>
  );
};

export default CoachSection;
